
import React from "react";
import { motion } from "framer-motion";


const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 1) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" }
    })
};

const About = ({ id }) => (
    <section id={id} className="py-20 px-4">
        <div className="container mx-auto">
                    <motion.h2
                        className="text-3xl md:text-4xl font-bold text-center mb-12 text-white"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={1}
                    >
                        About Me
                        <div className="w-24 h-1 bg-cyan-400 mx-auto mt-2 rounded"></div>
                    </motion.h2>
            <div className="flex flex-col md:flex-row items-center gap-10">
                        <div className="md:w-2/3 text-lg text-gray-300 space-y-4 text-center md:text-left">
                            <motion.p
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                variants={fadeInUp}
                                custom={2}
                            >
                                As a Junior Software Developer, I bring fresh enthusiasm and a passion for creating engaging web experiences. My skill set includes proficiency in web development, user interface design, HTML, CSS, PHP, and React.js.
                            </motion.p>
                            <motion.p
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                variants={fadeInUp}
                                custom={3}
                            >
                                I am eager to contribute my creativity and problem-solving abilities to elevate frontend design and deliver exceptional user experiences. I'm a lifelong learner, always excited to pick up new technologies and improve my craft.
                            </motion.p>
                            <motion.p
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                variants={fadeInUp}
                                custom={4}
                            >
                                When I'm not coding, I enjoy travelling, analyzing market trends, and watching movies.
                            </motion.p>
                        </div>
                        <motion.div
                            className="md:w-1/3 flex justify-center"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.5 }}
                            variants={fadeInUp}
                            custom={5}
                        >
                            <motion.div
                                className="w-64 h-64 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shadow-2xl"
                                initial={{ scale: 0.8, opacity: 0 }}
                                whileInView={{ scale: 1, opacity: 1 }}
                                viewport={{ once: true, amount: 0.5 }}
                                transition={{ delay: 1, duration: 0.8, type: "spring" }}
                                whileHover={{ scale: 1.05, rotate: 2 }}
                            >
                                <motion.img
                                    src="https://placehold.co/240x240/1a202c/ffffff?text=RB"
                                    alt="Rajan Bhalodiya"
                                    className="w-[230px] h-[230px] rounded-full object-cover border-4 border-gray-800"
                                    initial={{ opacity: 0, y: 40 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.5 }}
                                    transition={{ delay: 1.2, duration: 0.7, ease: "easeOut" }}
                                />
                            </motion.div>
                        </motion.div>
            </div>
        </div>
    </section>
);

export default About;
